import React from 'react';
import { useTranslation } from 'react-i18next';
import { Icon, Table } from 'semantic-ui-react';

import { bem } from '../../core/design/bem';
import { GroupWithInvited } from '../types';

const css = bem('GroupsTable');
const translationPrefix = 'group-visits';

type GroupsTableProps = {
  groups: GroupWithInvited[];
  onDetails: (group: GroupWithInvited) => void;
};

const GroupsTable = ({ groups, onDetails }: GroupsTableProps): JSX.Element => {
  const { t } = useTranslation();

  return (
    <Table fixed selectable unstackable className={css().toString()}>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell>{t(`${translationPrefix}.table.group`)}</Table.HeaderCell>
          <Table.HeaderCell textAlign="center">
            {t(`${translationPrefix}.table.guests`)}
          </Table.HeaderCell>
          <Table.HeaderCell textAlign="center">
            {t(`${translationPrefix}.table.confirmed`)}
          </Table.HeaderCell>
          <Table.HeaderCell textAlign="center">
            {t(`${translationPrefix}.table.refused`)}
          </Table.HeaderCell>
          <Table.HeaderCell textAlign="center">
            {t(`${translationPrefix}.table.pending`)}
          </Table.HeaderCell>
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {groups.map((group) => {
          const title = group.name || group.inviterName || t(`${translationPrefix}.card.untitled`);
          return (
            <Table.Row
              key={group._id}
              className={css('row').toString()}
              onClick={() => onDetails(group)}
            >
              <Table.Cell>
                <span className={css('name').toString()}>{title}</span>
                {group.inviterName && group.name && (
                  <span className={css('inviter').toString()}>
                    <Icon name="user" />
                    {group.inviterName}
                  </span>
                )}
              </Table.Cell>
              <Table.Cell textAlign="center">{group.totalCount}</Table.Cell>
              <Table.Cell textAlign="center" positive={group.registeredCount > 0}>
                {group.registeredCount}
              </Table.Cell>
              <Table.Cell textAlign="center" negative={group.refusedCount > 0}>
                {group.refusedCount}
              </Table.Cell>
              <Table.Cell textAlign="center" warning={group.pendingCount > 0}>
                {group.pendingCount}
              </Table.Cell>
            </Table.Row>
          );
        })}
      </Table.Body>
    </Table>
  );
};

export default GroupsTable;
